import { render, staticRenderFns } from "./broker-nav-links.vue?vue&type=template&id=45a897f9"
import script from "./broker-nav-links.vue?vue&type=script&lang=js"
export * from "./broker-nav-links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports